<ion-header class="ion-no-border">
  <ion-toolbar mode="md">
    <ion-buttons slot="start">
      <ion-button
        (click)="closeModalWithCancel()"
        aria-label="Cancelar"
      >
        <ion-icon
          slot="icon-only"
          src="../assets/material-symbols/close_24dp_FILL0_wght400_GRAD0_opsz24.svg"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Buscar código postal / ciudad</ion-title>
  </ion-toolbar>
  @if (countries$ | async; as countries) {
    <ion-toolbar>
      <form [formGroup]="formAddressEdit">
        <ion-grid class="">
          <ion-row>
            <ion-col size="4">
              <ion-select
                label="País"
                interface="popover"
                label-placement="floating"
                fill="outline"
                mode="md"
                multiple="false"
                name="country"
                formControlName="country"
              >
                @for (country of countries; track country.isoCode) {
                  <ion-select-option [value]="country.isoCode">{{ country.name }}</ion-select-option>
                }
              </ion-select>
            </ion-col>
            <ion-col size="8">
              <ion-input
                #postalCodeInput
                type="text"
                label="Código postal / localidad"
                name="postalCode"
                formControlName="postalCode"
                (ionInput)="handleChangeTerm($event)"
                placeholder="Código postal / localidad"
                labelPlacement="floating"
                fill="outline"
                mode="md"
                clearInput
              ></ion-input>
            </ion-col>
          </ion-row>
        </ion-grid>
      </form>
    </ion-toolbar>
  }
</ion-header>

<ion-content class="">
  @if (places$ | async; as places) {
    @if (loading) {
      <lib-spinner-loading></lib-spinner-loading>
    } @else {
      @for (place of places; track $index) {
        <ion-item
          button="true"
          (click)="handleSelectedPostalCode(place)"
        >
          <ion-label>({{ place.countryCode }}) {{ place.postalCode }} {{ place.city }}</ion-label>
        </ion-item>
      } @empty {
        <ion-item>
          <ion-label>No hay resultados. Cambie los términos de búsqueda.</ion-label>
        </ion-item>
      }
    }
  }
</ion-content>
